
export default [
  {
    url: '/user/logingout',
    type: 'post',
    response: _ => {
      return {
        code: 1,
        data: 'success'
      }
    }
  },

  {
    url: '/user/logingout',
    type: 'post',
    response: _ => {
      return {
        code: 1,
        data: 'success'
      }
    }
  },

  {
    url: '/user/querydoctype',
    type: 'post',
    response: _ => {
      return {
        "code": 1,
        "info": "ok",
        "pageno": 0,
        "pagesize": 0,
        "totalcount": 0,
        "list": [
          {
            "datastatus": "1",
            "doctorid": "1758184996624826368",
            "doctype": "1",
            "doctypename": "云账号",
            "name": "云平台",
            "rolename": "云超级管理员"
          }
        ],
        "main": null,
        "command": "",
        "data": null
      }
    }
  },

  {
    url: '/user/setdoctype',
    type: 'post',
    response: _ => {
     return  {
      "code": 1,
      "info": "ok",
      "pageno": 0,
      "pagesize": 0,
      "totalcount": 0,
      "list": {
        "checkingconfirmed": 0,
        "diagnosisconfirmed": 0,
        "doctype": "3",
        "groupid": "100001,140001,200001,300001,600001,140001",
        "hospitalid": "5142864482355216384",
        "name": "超级审核管理员",
        "needcloud": "0",
        "partnershipid": "8202723025599168512",
        "rightlist": "30300001,30100001,30200001,30400001",
        "rolename": "医院报告医生",
        "show": "0",
        "showcheck": 0,
        "showdiagnosis": 0
      },
      "main": null,
      "command": "",
      "data": null
    }
   }
  },
  {
    url: '/user/personalcenter',
    type: 'post',
    response: _ => {
     return  {
      "code": 1,
      "info": "ok",
      "pageno": 0,
      "pagesize": 0,
      "totalcount": 0,
      "list": [
        {
          "address": "",
          "advancehandsel": "",
          "advancepay": "",
          "age": "2",
          "area": "",
          "basicunit": "",
          "birthday": "2020-08-04",
          "city": "",
          "depart": "",
          "disease": "",
          "doctorid": "4481862665991258112",
          "doctype": "2",
          "doctypename": "",
          "duty": "",
          "hosorgancode": "",
          "hospitalcode": "",
          "hospitalid": "",
          "hospitalname": "",
          "idcards": "130633198409243330",
          "mobile": "13631512012",
          "name": "医匠第二影像中心",
          "organcode": "",
          "organize": "",
          "partnercode": "10006",
          "partnershipid": "6126874654968741888",
          "picture": "",
          "province": "",
          "rolename": "医联体审核医生",
          "sex": "男",
          "signurl": "/img/sign/80a00c92d0e996864ba3cba68acf1567_620726138213138432.png",
          "title": "",
          "userid": "3609256342121971712",
          "username": "苑"
        }
      ],
      "main": null,
      "command": "",
      "data": null
    }
   }
  },
  {
    url: '/pat/getdictonary',
    type: 'post',
    response: _ => {
     return  {
      "code": 1,
      "info": "ok",
      "pageno": 0,
      "pagesize": 0,
      "totalcount": 0,
      "list": null,
      "main": null,
      "command": "",
      "data": null
    }
   }
  },
  {
    url: '/admin/getdiagnosisdoc',
    type: 'post',
    response: _ => {
     return  {
      "code": 1,
      "info": "ok",
      "pageno": 0,
      "pagesize": 0,
      "totalcount": 0,
      "list": [],
      "main": null,
      "command": "",
      "data": null
    }
   }
  },
  {
    url: '/admin/getcheckdoc',
    type: 'post',
    response: _ => {
     return  {
      "code": 1,
      "info": "ok",
      "pageno": 0,
      "pagesize": 0,
      "totalcount": 0,
      "list": [],
      "main": null,
      "command": "",
      "data": null
    }
   }
  },
]
